import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  clear({ currentTarget: input, isTrusted }) {
    if (!isTrusted) return

    input.classList.remove('input-error')
    input.removeAttribute('aria-invalid')

    const error = input.parentElement.nextElementSibling

    if (error && error.classList.contains('field-inline-error')) {
      error.remove()
    }
  }
}
